export default function detectTouch() {
    if (typeof window !== 'undefined') {
        return Boolean(
            'ontouchstart' in window ||
                window.navigator.maxTouchPoints > 0 ||
                window.navigator.msMaxTouchPoints > 0
        );
    }
}
